/* eslint-disable max-len */
/**
 * German translations.
 */
export default {
  ACTION: {},
  ERROR: {},
  HEADER: {},
  LABEL: {
    NO_ROWS_MENTIONS: 'Keine Erwähnungen'
  },
  SENTENCE: {
    INSTAGRAM_LINK:
      'Du hast Prozis am {publishedAt} in einer Instagram Story erwähnt',
    NO_ROWS_MENTIONS: 'Du hast Prozis noch nicht auf deinem Instagram erwähnt'
  },
  SUCCESS: {},
  TOOLTIP: {}
};
